<script >
import { ref, reactive, computed, defineAsyncComponent, onBeforeMount, set } from 'vue-demi';
import '@futuweb/quote-charts/lib/SparkChart/style/index.css';
const SparkChart = defineAsyncComponent(() => import('@futuweb/quote-charts/lib/SparkChart'));
import { getSchemeLink, PROTOCOL_TYPE } from './scheme';
const __sfc_main = {};
__sfc_main.props = {
  market_id: [Number, String],
  sort_id: Number,
  language: Number,
  upDownColor: Number,
  title: String,
  subTitle: String,
  topImg: String,
  count: Number,
  customStocklist: Array,
  schemeType: String,
  schemeProtocol: {
    type: String,
    default: PROTOCOL_TYPE.MOOMOO
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const DEFAULT_IMG =
  // eslint-disable-next-line max-len
  'https://static.futunn.com/upload/01fego/wecom-temp-a4a5d8dc67ffbdb20d121301fcdc00ab-a5f06cc9f247bd53342ca7899d7edad9.png?_=1680160592562';
  const {
    usePageType,
    useCommonApi,
    useBehaviour
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const {
    runBehaviour
  } = useBehaviour();
  const request = useCommonApi('quote-rank');
  const stockList = ref([]);
  const chartDatas = reactive({});
  const props = __props;

  /* 自定义股票排行 */
  const isCustomRank = computed(() => props.market_id === 'custom');
  const symbolListStr = computed(() => {
    const symbolList = (props.customStocklist || []).map(stock => stock.symbol || '');
    return symbolList.filter(item => !!item.trim()).join(',');
  });
  const getCustomRank = async () => {
    const data = {
      symbols: symbolListStr.value,
      lang: props.language,
      count: props.count
    };
    try {
      return await request.get('get-custom-rank-list', data);
    } catch (err) {
      console.error('custom-rank', err);
    }
  };

  /* 市场排行 */
  const getMarketRank = async () => {
    const data = {
      sort_id: props.sort_id,
      market_id: props.market_id,
      lang: props.language,
      count: props.count
    };
    try {
      return await request.get('get-rank-list', data);
    } catch (err) {
      console.error('market-rank', err);
    }
  };

  /* 股票图表数据 */
  const getChartData = async stock => {
    const params = {
      symbol: stock.symbol,
      stock_id: stock.stockId,
      market_code: stock.marketCode,
      type: 1,
      // 0代表 盘中数据
      req_section: 0
    };
    const r = await request.get('quote-minute', params);
    r.price_direct = stock.priceDirect;
    return r;
  };
  const initChartData = () => {
    if (!stockList.value || !stockList.value.length) {
      return;
    }
    stockList.value.map(async stock => {
      const chartData = (await getChartData(stock)) || [];
      set(chartDatas, stock.stockId, chartData);
    });
  };
  const goScheme = stock => {
    if (props.schemeType) {
      const link = getSchemeLink(props.schemeType, stock, props.schemeProtocol || PROTOCOL_TYPE.MOOMOO);
      link && runBehaviour(null, {
        type: props.schemeProtocol === PROTOCOL_TYPE.NN ? 'jump' : 'jumpMM',
        value: link
      });
    }
  };
  const getRankList = async () => {
    stockList.value = isCustomRank.value ? await getCustomRank() : await getMarketRank();
    initChartData();
  };
  onBeforeMount(() => {
    getRankList();
  });
  return {
    DEFAULT_IMG,
    isPC,
    stockList,
    chartDatas,
    goScheme
  };
};
__sfc_main.components = Object.assign({
  SparkChart
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div
        :class="[
            'quote-rank',
            {
                pc: isPC
            }
        ]"
    >
        <div class="topbar">
            <img class="banner" :src="topImg || DEFAULT_IMG" alt="" />
            <p class="title" v-html="title"></p>
            <p class="sub-title" v-html="subTitle"></p>
        </div>
        <div class="stocks">
            <div class="stock-item" v-for="(stock, index) in stockList" :key="index" @click="goScheme(stock)">
                <div :class="['rank', { after: index > 2 }]">{{ index + 1 }}</div>
                <div class="left">
                    <div class="short-name">{{ stock.shortName }}</div>
                    <div class="name">{{ stock.name }}</div>
                </div>
                <div class="right">
                    <SparkChart
                        v-if="chartDatas && chartDatas[stock.stockId]"
                        class="chart"
                        :dataSource="chartDatas && chartDatas[stock.stockId]"
                        :upDownColor="upDownColor"
                        :marketId="market_id"
                    />
                    <span :class="[`ratio color-${upDownColor || 0}`, { down: stock.priceChange < 0 }]">
                        {{ stock.ratioPriceChange }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import './index.less';
</style>
